export enum EPostOrigin {
  /** Integration channel — occurrence opened through an embedded iframe */
  IFRAME = 25,
}
